import { Speaker } from '../types'
import { FallbackImg } from './FallbackImg'
import { useResponsiveSceneProps } from './ResponsiveSceneContext'

interface ParticipantProps {
  size: number
  speaker: Speaker
}

export default function Participant({ size, speaker }: ParticipantProps) {
  const { audiogram } = useResponsiveSceneProps()

  return (
    <div className="flex flex-row">
      <FallbackImg
        className="rounded-full"
        style={{ width: size, height: size }}
        src={speaker.avatarUrl}
      />

      <div
        className="flex flex-row items-center"
        style={{
          color: audiogram.theme.colors.secondary,
          paddingLeft: 0.375 * size,
          fontFamily: audiogram.theme.fonts.primary,
          fontSize: 0.5 * size,
          height: size,
        }}
      >
        {speaker.username}
      </div>
    </div>
  )
}
